/**
 * Slider.js
 * Created on 08/17/2021.
 */

import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import {GetCardTypeForBody} from '../../../../../util/utils';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';
import BodyKnowledgeDescriptionContentSide from '../BodyKnowledgeDescriptionContentSide';
import ReactSliderLegend from '../../../ReactSlider/ReactSliderLegend';

export default function SliderLegend(props) {
	const {
		isAresView,
		showGuidance,
		guidanceFilter,
		options,
		headerId,
		sectionId,
		bodyId,
		getBodiesBySectionId,
		isSnapshotView
	} = props;

	const [sliderBodyData, setSliderBodyData] = useState([]);

	const engagementId = useEngagementId(),
		documentId = useDocumentId();

	useEffect(() => {
		let bodyData = _.cloneDeep(options.optionsAndResponses);

		if (bodyData && bodyData.length > 0) {
			let filterBodyData = bodyData.map((obj) => ({
				...obj,
				isChecked: obj.bodyOptionId === obj.bodySelectedOptionId
			}));
			setSliderBodyData(filterBodyData);
		} else {
			setSliderBodyData([]);
		}
	}, [options.optionsAndResponses]);

	const formBodyBorder = GetCardTypeForBody(options, isAresView);

	return (
		<Wrapper className={`SectionBodyWrapper sectionBodySliderLegend ${formBodyBorder}`}>
			{options.optionsAndResponses && options.optionsAndResponses.length > 0 && (
				<BodyKnowledgeDescriptionContentSide
					isAresView={isAresView}
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
					isSnapshotView={isSnapshotView}
					bodyModel={options}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={options.name}
					isCustom={options.isCustom}
					isDuplicate={options.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
				>
					<section className="SectionBodyData SectionBodyDataSliderLegend" id={bodyId}>
						<section className="SectionBodySlider SectionBodySliderLegends">
							<ReactSliderLegend
								value={options.optionsAndResponses}
								bodyId={bodyId}
								className={'ReactSliderLegendBody'}
							/>
						</section>
					</section>
				</BodyKnowledgeDescriptionContentSide>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	&.sectionBodySliderLegend {
		min-height: var(--px-65);
	}
	.SectionBodyDataWrapper {
		margin-left: auto;
		margin-top: var(--px-10);
		padding-left: 0 !important;
	}
	.SectionBodyData {
		flex-direction: unset !important;
		padding: 0;
		width: var(--px-500);
		.SectionBodySlider {
			.hideSelectorforAnswer {
				.handleSlider {
					background: var(--neutrals-00white);
					border: var(--px-1) solid var(--neutrals-300);
				}
			}
		}
	}
`;
